<div class="block-modal">
  <div class="box-modal">
    <div class="titulo-modal">
      Validação
      <i (click)="fechar()" class="far fa-times"></i>
    </div>
    <div class="conteudo-modal">

      <div *ngIf="isLoading" class="loading-envio">
        <i class="far fa-circle-notch fa-spin fa-3x fa-fw"></i>
        <p>Enviando chave, aguarde...</p>
      </div>

      <div *ngIf="!isLoading && !isError && dataConfirmacao" class="box-form">

        <div *ngIf="dataConfirmacao?.tipoConfirmacao?.value == '1'" class="label-form">
          <span>Informe a chave recebida por SMS</span>
          <br>
          <small>Enviada para n&uacute;mero {{dataConfirmacao.envioConfirmacao}}</small>
        </div>
        <div *ngIf="dataConfirmacao?.tipoConfirmacao?.value == '2'" class="label-form">
          <span>Informe a chave recebida por e-mail</span>
          <br>
          <small>Enviada para o endereço {{dataConfirmacao.envioConfirmacao}}</small>
        </div>

        <maf-form #formConfirmacao>
          <maf-input-text #setFocusConfirmacao [(ngModel)]="chaveConfirmacao" (keyup.enter)="validarChaveConfirmacao()" [valid]="isValidConfirmacao" [disabled]="isLoadingConfirmacao" [maxLength]="4" ngDefaultControl></maf-input-text>
          <div class="btn-default-loja-virtual">
            <maf-button (click)="validarChaveConfirmacao()" [loading]="isLoadingConfirmacao" [disabled]="!formConfirmacao.valid || chaveConfirmacao == null || chaveConfirmacao.length != 4">&nbsp;CONTINUAR</maf-button>
          </div>
        </maf-form>
      </div>

      <div *ngIf="!isLoading && isError">
        <p class="alerta">
          Não foi possível validar seu cadastro, entre em contato
          <a (click)="validacaoWhatsApp()" class="ajuda-whatsapp-lojas">
            <i class="fab fa-whatsapp"></i>
            <span>&nbsp;{{parametrosAPP.whatsApp > 0 ? (formatarWhats()) : ''}}</span>
          </a>
          e verifique seu cadastro.
        </p>
      </div>
    </div>
  </div>
</div>
